import { definePreset } from '@primeng/themes';
import material from '@primeng/themes/material';

export const MyPreset = definePreset(material, {

});

